import React from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import { useLocation, useNavigate } from 'react-router-dom';
import { Step1, Step2, Step3 } from './Steps.constants';
import useSelectedFavourites from '../../../zustand/SelectedFavourites';
import { StyledDiv } from './MainStepper.styled';

const steps = [
  { ...Step1, path: '/favouriteselection' },
  { ...Step2, path: '/overviewfilter' },
  { ...Step3, path: '/bestcombination' },
];

const MainStepper = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { selectedTeams, selectedCompetitions } = useSelectedFavourites();
  const activeStep = steps.findIndex((step) => step.path === location.pathname);

  const handleStep = (index: number) => () => {
    navigate(steps[index].path);
  };
  const isActive =
    location.pathname === '/favouriteselection' ||
    location.pathname === '/overviewfilter' ||
    location.pathname === '/bestcombination';

  const canAccessStep2 =
    selectedTeams.length > 0 || selectedCompetitions.length > 0;
  const canAccessStep3 = canAccessStep2;

  return (
    <>
      {isActive && (
        <StyledDiv>
          <Stepper nonLinear activeStep={activeStep}>
            {steps.map((step, index) => (
              <Step key={step.label}>
                <StepButton
                  color="inherit"
                  onClick={handleStep(index)}
                  disabled={
                    (index === 1 && !canAccessStep2) ||
                    (index === 2 && !canAccessStep3)
                  }
                >
                  {step.label}
                </StepButton>
              </Step>
            ))}
          </Stepper>
        </StyledDiv>
      )}
    </>
  );
};

export default MainStepper;
